import moment from 'moment';
import { Link } from 'react-router-dom';
import { useAuthContextValueHook } from '@/contexts/AuthContext';
import { useMySubscriptionsQuery } from '@/hooks/ReactQuery/SubscriptionReactQuery/SubscriptionReactQuery';

const STATUS = {
    ACTIVE: { label: '이용 중', className: 'bg-emerald-50 text-emerald-600' },
    CANCELED: { label: '해지 예정', className: 'bg-amber-50 text-amber-600' },
    PAST_DUE: { label: '결제 실패', className: 'bg-red-50 text-red-600' },
    EXPIRED: { label: '종료', className: 'bg-gray-100 text-gray-500' },
};

/**
 * 프로필: 어떤 페이지에 어떤 구독이 들어가 있는지 (구독은 페이지 단위)
 */
export function WegetSubscriptions() {
    const authContextValueHook = useAuthContextValueHook();
    const query = useMySubscriptionsQuery({ enabled: authContextValueHook?.isLoggedIn && authContextValueHook?.isReady });
    const items = query.data?.items || [];

    return (
        <div className="mx-auto mt-5 max-w-[600px] px-[10px]">
            <section className="rounded-2xl bg-white p-5 ring-1 ring-black/[0.06]">
                <h2 className="text-base font-bold text-gray-900">구독 관리</h2>
                <p className="mt-0.5 text-[13px] text-gray-500">슈룩 Pro 는 페이지마다 따로 구독해요.</p>

                {query.isLoading && <div className="mt-4 h-14 animate-pulse rounded-xl bg-gray-50" />}
                {!query.isLoading && items.length === 0 &&
                    <p className="mt-4 rounded-xl bg-gray-50 px-4 py-3 text-[13px] text-gray-500">구독 중인 페이지가 없어요. 마이 페이지의 &lsquo;요금제&rsquo; 탭에서 Pro 를 시작할 수 있어요.</p>
                }
                {items.length > 0 &&
                    <ul className="mt-3 divide-y divide-gray-100">
                        {items.map(item => (
                            <li key={item.id}>
                                <Link to={`/mypage/${item.userPageId}?tabType=PLAN`} className="flex items-center gap-3 rounded-xl px-2 py-3 hover:bg-gray-50">
                                    <span className="min-w-0 flex-1">
                                        <span className="block truncate text-[15px] font-semibold text-gray-900">shool.uk/{item.domainName || '(삭제된 페이지)'}</span>
                                        <span className="block text-xs text-gray-500">
                                            슈룩 Pro · 월 {Number(item.amount).toLocaleString('ko-KR')}원
                                            {item.status === 'ACTIVE' && item.nextBillingAt && ` · 다음 결제 ${moment(item.nextBillingAt).format('YYYY.MM.DD')}`}
                                            {item.status === 'CANCELED' && ` · ${moment(item.currentPeriodEnd).format('YYYY.MM.DD')}까지 이용`}
                                            {item.status === 'EXPIRED' && item.currentPeriodEnd && ` · ${moment(item.currentPeriodEnd).format('YYYY.MM.DD')} 종료`}
                                        </span>
                                    </span>
                                    <span className={`shrink-0 rounded-full px-2 py-0.5 text-xs font-bold ${STATUS[item.status]?.className}`}>{STATUS[item.status]?.label}</span>
                                    <span className="shrink-0 text-gray-300" aria-hidden="true">›</span>
                                </Link>
                            </li>
                        ))}
                    </ul>
                }
            </section>
        </div>
    );
}
